import { CommonProductQueryParams } from '~/api/easy-estimator-api/commonProductQueryParams';
import { easyEstimatorApi } from '~/api/easy-estimator-api/easyEstimatorService';
import { ApiUrl } from '~/core/enums';
import { PlumbingProduct } from '~/core/models';

const plumbingService = easyEstimatorApi.injectEndpoints({
  endpoints: (builder) => ({
    fetchPlumbing: builder.query<PlumbingProduct[], CommonProductQueryParams>({
      query: ({ params }) => ({
        url: ApiUrl.PLUMBING,
        method: 'GET',
        params,
      }),
    }),
  }),
});

export const { useFetchPlumbingQuery, useLazyFetchPlumbingQuery } =
  plumbingService;
